import { setupData } from "./setupData";

const TitleIcon = ({icon, title}) => {
    return (
        <div className=" flex gap-[12px] items-center">
            
            <div className="w-[50px] h-[50px] bg-white rounded-[50%] shadow-[0px_0.7999999523162842px_1.5999999046325684px_0.3999999761581421px_rgba(13,77,184,0.40)] inline-flex justify-center items-center">
                <div className="w-[38px] h-[38px] bg-[#d3aa86] rounded-[50%] flex justify-center items-center">
                    <img src={icon} alt="rocker" className={`w-[30px]`} />
                </div>
            </div>

            <div className={`text-[#d3aa86] text-[20px] font-bold font-['Open_Sans'] w-[200px] md:w-[250px]`}>
                {title}
            </div>
        </div>
    )
}

const LeadCard = ({ index, card }) => {
    const pos = "text-left";
    const flex_dir = "flex-row";
    
    return (
        <div className={`w-full flex ${flex_dir} justify-center items-between z-10`}>
            

            <div className="flex flex-col justify-center items-start gap-2.5 w-full">
                
                <TitleIcon title={card.title} icon={card.icon} />
            

                <div className="flex flex-col justify-end items-start gap-2.5 w-full mt-[10px] pl-[54px]">
                    {card.items.map((item, index) => (
                        <div key={index} className={`w-full ${pos} justify-start text-stone-700 text-[16px] font-normal font-['Open_Sans']`}>
                            {item}
                        </div>
                    ))}
                </div>
                <div className="w-full flex justify-end mb-[56px] mt-[24px]">
                    <div className="text-center text-[20px] leading-normal  font-bold font-['Inter'] bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text flex">
                            {card.duration}
                    </div>
                </div>
            </div>            
        </div>
    )
}

export default function SetupMobile() {
    return (
        
        <div className="w-full flex flex-col justify-center h-[1560px] md:h-[1460px]">        

            <div className="w-[290px] md:w-[380px] h-full flex flex-col justify-start items-center mx-auto py-[90px] relative">
                    
                <hr className="absolute h-[1px] w-[1420px] md:w-[1260px] bg-[#d3aa86] border-[#d3aa86] rotate-[90deg] top-[810px] md:top-[740px] ml-[-240px] md:ml-[-330px] z-0" />

                <div className="w-[10px] h-[10px] bg-[#d3aa86] absolute bottom-[40px] md:bottom-[90px] ml-[-240px] md:ml-[-330px] rounded">

                </div>

                {setupData.map((card, index) => (
                    <LeadCard key={index} index={index} card={card} />
                ))}
            </div>
        </div>
    );
}